import { useLocation } from 'react-router-dom';

import { USER_DOMAIN } from '@/shared/constants/user-domain.constant';
import { getDomainFromPathname } from '@/shared/lib/helpers/get-domain-from-pathname.helper';

/**
 * Domain from the route prefix. Reactive version of getCurrentDomain:
 * pass it into query args so RTK Query keeps a separate cache per domain
 */
export const useCurrentDomain = (): USER_DOMAIN => {
	const { pathname } = useLocation();

	return getDomainFromPathname(pathname) ?? USER_DOMAIN.YACHTING;
};
